import { useState } from "react";
import { IoClose } from "react-icons/io5";

import { useAccount } from "wagmi";

import { useDelegatorValidatorsQuery } from "shared/api/cosmos/use-delegator-validators-query";
import {
  Validator,
  useValidatorsQuery,
} from "shared/api/cosmos/use-validators-query";
import { Checkbox } from "shared/ui/checkbox";
import { Dialog } from "shared/ui/dialog";

import { Header } from "./table/header";
import { Row } from "./table/row";
import { Table } from "./table/table";

type Props = {
  onDelegate: (validator: Validator) => void;
};

export function SelectValidatorDialog(props: Props) {
  const { onDelegate } = props;
  const { address } = useAccount();
  const [search, setSearch] = useState("");
  const [onlyDelegatorValidators, setOnlyDelegatorValidators] = useState<
    "indeterminate" | boolean
  >(false);

  const query = useValidatorsQuery();

  const delegatorValidatorsQuery = useDelegatorValidatorsQuery({ address });
  const delegatorValidators = delegatorValidatorsQuery.data?.validators ?? [];

  const targetValidators = onlyDelegatorValidators
    ? delegatorValidators
    : (query.data?.data.validators ?? []);

  const validators = targetValidators.filter((validator) =>
    validator.description?.moniker?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Dialog.Content className="h-[50vh] min-h-[500px] w-[80vh] max-w-[900px] min-w-[800px] rounded-lg bg-white px-6 pt-6 shadow-md">
      <Dialog.Close className="absolute top-4 right-4 flex size-11 items-center justify-center">
        <IoClose className="text-santaGrey size-7 hover:brightness-90" />
      </Dialog.Close>
      <Dialog.Title className="text-center text-xl font-semibold">
        Validator Squad
      </Dialog.Title>
      <p className="text-riverBed mx-auto mt-1.5 w-2/3 text-center text-sm">
        Select the validators you’d like to delegate to. Once complete, continue
        to stake. You may edit your validator set at any time.
      </p>
      <div className="mt-5 mb-4 flex items-center justify-end gap-x-4">
        <div className="text-mistBlue flex items-center gap-x-1.5 text-xs">
          <Checkbox
            checked={onlyDelegatorValidators}
            onCheckedChange={setOnlyDelegatorValidators}
          />
          <span>My position</span>
        </div>

        <input
          className="border-dawnPink2 w-[200px] rounded-sm border px-2 py-1 text-xs outline-hidden"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search"
          type="text"
          value={search}
        />
      </div>

      <Table>
        <Header />
        {validators?.map((validator, index) => {
          const hasDelegation = delegatorValidators.some(
            ({ operator_address }) =>
              validator.operator_address === operator_address
          );
          return (
            <Row
              hasDelegation={hasDelegation}
              index={index + 1}
              key={index}
              onDelegate={() => onDelegate(validator)}
              validator={validator}
            />
          );
        })}
      </Table>
    </Dialog.Content>
  );
}
